/**
 * The trip page's "Redeem on this trip" tiles: the fewest Defera Miles each
 * request starts from. The tiles (FlightDetailsModal), the concierge's
 * knowledge base (server/tommy-concierge.js) and the Help Center all read
 * these, so they can't drift apart.
 */
export const MILES_TILE_MINIMUMS = Object.freeze({ seats: 1500, baggage: 3500, cabin: 8000 });
